/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestions.defs.js'
export * as $defs from './getSuggestions.defs.js'
